import { render, staticRenderFns } from "./UserGroupsModal.vue?vue&type=template&id=672252a8&scoped=true&"
import script from "./UserGroupsModal.vue?vue&type=script&lang=js&"
export * from "./UserGroupsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672252a8",
  null
  
)

export default component.exports